import { Spin, Typography } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { Socket } from "socket.io-client";
import { useGetOneTransaction } from "../../../../api/currency";
import { ButtonOutlinedCustom } from "../../../../components/button/buttonOulined";
import PaymentStatus from "../../../../types/paymentStatus.type";
import useResponsive from "../../../../utils/hooks/useResponsive";
import { formatNumber } from "../../../../utils/list.utils";
import StatusForm from "./status-form";
import TextContent from "./text-content";

const FormCryptoWithdrawals = ({
  orderId,
  socket,
  handleCancelOrder,
  data,
  isLoading,
  refetch,
}: {
  orderId: string;
  socket: Socket<any, any>;
  handleCancelOrder: (id: any) => void;
  data: any;
  isLoading: boolean;
  refetch: any;
}) => {
  const { isTablet } = useResponsive();

  const reasonStatus = () => {
    switch (data?.data?.data?.status) {
      case PaymentStatus.PENDING:
        return "To finalize your withdrawal, please wait while your request is being reviewed.";
      case PaymentStatus.REJECTED:
        return data?.data?.data?.reason || "N/A";
      case PaymentStatus.CANCELLED:
        return (
          data?.data?.data?.reason ||
          "You’ve canceled the withdrawal order. Funds remain in your account."
        );
      case PaymentStatus.FAILED:
        return data?.data?.data?.reason || "N/A";
      case PaymentStatus.COMPLETED:
        return (
          data?.data?.data?.reason ||
          "Withdrawal has been completed. Check your portfolio for details."
        );
      default:
        return "";
    }
  };

  useEffect(() => {
    if (!orderId) return;
    const handleDetailWalletUpdated = () => {
      refetch();
    };
    socket.on(
      `user.walletOrder.${Number(orderId)}.updated`,
      handleDetailWalletUpdated
    );

    return () => {
      socket.off(
        `user.walletOrder.${Number(orderId)}.updated`,
        handleDetailWalletUpdated
      );
    };
  }, [socket, orderId, refetch]);

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            minHeight: "438px",
          }}
        >
          <Spin size="large" className="custom-spin" />
        </div>
      ) : (
        <div>
          <div className="form-history">
            <StatusForm
              status={data?.data?.data?.status || ""}
              content={reasonStatus()}
            />
            <div className="modal-balance">
              <div className="value-balance">
                <Typography style={{ fontSize: 16, color: "white" }}>
                  Amount
                </Typography>
                <Typography.Text className="text-gradient">
                  {formatNumber(
                    Number(data?.data?.data?.amount) || 0,
                    data?.data?.data?.decimals
                  )}{" "}
                  <Typography.Text
                    className="text-gradient"
                    style={{
                      fontSize: isTablet ? "20px" : "24px",
                    }}
                  >
                    {data?.data?.data?.currency}
                  </Typography.Text>
                </Typography.Text>
              </div>
            </div>
            <div className="form-history-content">
              <TextContent
                label="Beneficiary Will Receive"
                value={`${(
                  Number(data?.data?.data?.amount) -
                  Number(data?.data?.data?.fees)
                ).toFixed(data?.data?.data?.decimals)} ${data?.data?.data?.currency || ""
                  }`}
                color="rgba(242, 138, 40, 1)"
              />
            </div>
            <div className="form-history-content border-top">
              <TextContent label="Currency" value={data?.data?.data?.currency} />
              <TextContent
                label="Chain Type"
                value={data?.data?.data?.chainType}
              />
              <TextContent
                label={
                  data?.data?.data?.type === "ONCHAIN_WITHDRAWAL"
                    ? "Address"
                    : "Beneficiary"
                }
                value={
                  data?.data?.data?.beneficiary ||
                  data?.data?.data?.address ||
                  "N/A"
                }
                canCopy={data?.data?.data?.type === "ONCHAIN_WITHDRAWAL"}
              />
              <TextContent
                label="Fees"
                value={`${formatNumber(
                  data?.data?.data?.fees || "0",
                  data?.data?.data?.decimals
                )} ${data?.data?.data?.symbol || ""}`}
              />
            </div>
            <div className="form-history-content border-top">
              <TextContent
                label="Time"
                value={moment(data?.data?.data?.createdAt).format(
                  "HH:mm:ss DD/MM/YYYY"
                )}
              />
            </div>
          </div>
          {data?.data?.data?.status === PaymentStatus.FAILED ||
            data?.data?.data?.status === PaymentStatus.PENDING ? (
            <div className="form-withdraw-button">
              <ButtonOutlinedCustom
                size={isTablet ? "medium" : "large"}
                text={"Cancel Withdrawal"}
                width={"100%"}
                className="outline-dangerous"
                onClick={() => handleCancelOrder(data?.data?.data?.id)}
              />
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default FormCryptoWithdrawals;
